<mat-toolbar color="primary" class="app-toolbar mat-elevation-z6">
    <mat-toolbar-row>
        <span fxHide.xs> {{ "APP_TOOLBAR_TITLE" | translate }} </span>
        <div fxFlex fxLayout fxLayoutAlign="flex-end">
            <ul fxLayout fxLayoutGap="20px" style="list-style: none">
                <li>
                    <button mat-button [matMenuTriggerFor]="languageMenu" title="{{ 'NAVLIST.language' | translate }}">
                        {{ translateService.currentLang | uppercase }}
                    </button>
                    <mat-menu #languageMenu="matMenu">
                        @if (translateService.currentLang !== "it") {
                            <button mat-menu-item (click)="changeLanguageClick('it')" title="{{ 'NAVLIST.italian' | translate }}">IT</button>
                        }
                        @if (translateService.currentLang !== "de") {
                            <button mat-menu-item (click)="changeLanguageClick('de')" title="{{ 'NAVLIST.german' | translate }}">DE</button>
                        }
                        @if (translateService.currentLang !== "en") {
                            <button mat-menu-item (click)="changeLanguageClick('en')" title="{{ 'NAVLIST.english' | translate }}">EN</button>
                        }
                    </mat-menu>
                </li>
                @if (sessionExist) {
                    @if (!isRouteAI) {
                        <li>
                            <button mat-button class="ask-ava-button" (click)="chatbotService.toggle()">{{ "NAVLIST.askAva" | translate }}</button>
                        </li>
                    }
                    <li>
                        <button mat-icon-button (click)="viewProfile()" title="{{ 'PROFILE.UPDATE.title' | translate }}">
                            <mat-icon>person_outline</mat-icon>
                        </button>
                    </li>
                    <li>
                        <button mat-icon-button (click)="doUserLogout()" title="{{ 'NAVLIST.logout' | translate }}">
                            <mat-icon>exit_to_app</mat-icon>
                        </button>
                    </li>
                }
            </ul>
        </div>
    </mat-toolbar-row>
</mat-toolbar>
